package org.hs_soft.runmynesto.data.api_datasource.options.menu_card_import

import com.varabyte.kobweb.browser.http.AbortController
import kotlinx.serialization.json.*
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient

import org.hs_soft.runmynesto.domain.model.home.options.menu_card_import.menu_card_model.MenuCardModel
import org.hs_soft.runmynesto.domain.model.home.options.menu_card_import.upsert_products.UpsertProductsModel
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.AppConstantsEnum
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.menu_card_import.UpsertProductsRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.config.Errors

class UpsertProductsRepositoryImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
) : UpsertProductsRepository {

    private var abortController: AbortController? = null

    override suspend fun upsertProducts(
        menuCard: MenuCardModel,
        categoryIds: List<String>,
        ingredientIds: List<List<String>>,
        turnoverGroupIds: List<String?>,
        productLocationIds: List<List<Boolean>>
    ): UpsertProductsModel {
        abortController = requestManager.createController()

        val query = """
          mutation upsertProducts(${'$'}records: [NewProduct!]!) {
              cashAssist {
                  upsertProducts(records: ${'$'}records) {
                      id
                  }
              }
          }
      """.trimIndent()

        val variables = buildJsonObject {
            putJsonArray("records") {
                menuCard.items.mapIndexed {index, product ->
                    add(buildJsonObject {
                        putJsonObject("fields") {
                            put("name", product.name?:"")
                            put("code", product.productNumber?:"")
                            put("description", product.description?:"")
                            putJsonArray("priceInCafe") {
                                add(Regex("""\d+(\.\d+)?""").findAll(product.price ?: "0").map { it.value.toDoubleOrNull() }.filterNotNull().toList().minOrNull())
                            }
                            put("weight", product.weight?.takeIf { it.isNotBlank() }?.toDoubleOrNull())
                            put("isActive", true)
                            put("codeMWSt", AppConstantsEnum.VAT_NORMAL.value)
                            put("codeMWSt2", AppConstantsEnum.VAT_NORMAL.value)
                            putJsonArray("ingredients") {
                                ingredientIds[index]
                                    .filter { it != "-1" }
                                    .map { allergenId ->
                                        addJsonObject {
                                            put("id", allergenId)
                                            put("contains", true)
                                        }
                                    }
                            }
                            put("categoryId", categoryIds[menuCard.categories.indexOf(product.category?:"8")])
                            put("salesGroupId", turnoverGroupIds[index])
                            put("printerLocations",  Json.encodeToJsonElement(productLocationIds[index]))
                        }
                    })
                }
            }
        }

        val graphQLQuery = buildJsonObject {
            put("query", query)
            put("variables", variables)
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController!!,
        )

        return if (result != null) {
            Json.decodeFromString<UpsertProductsModel>(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }
    }
    
    override fun cancel() {
        abortController?.abort()
        abortController = null
    }
}